import { ComboboxOption } from '../../interfaces/common/ComboxOption';

const categoriesPes: ComboboxOption[] = [
  {
    key: '01',
    text: '01 Personnes Physiques',
    value: '01',
  },
  {
    key: '20',
    text: '20 État et établissement publics nationaux',
    value: '20',
  },
  {
    key: '21',
    text: '21 Régions',
    value: '21',
  },
  {
    key: '22',
    text: '22 départements',
    value: '22',
  },
  {
    key: '23',
    text: '23 Communes',
    value: '23',
  },
  {
    key: '24',
    text: '24 Groupements de collectivités',
    value: '24',
  },
  {
    key: '25',
    text: '25 Caisses des écoles',
    value: '25',
  },
  {
    key: '26',
    text: '26 CCAS',
    value: '26',
  },
  {
    key: '27',
    text: '27 Établissements publics de santé',
    value: '27',
  },
  {
    key: '28',
    text: '28 École nationale de la santé PUBLIQUE',
    value: '28',
  },
  {
    key: '29',
    text: '29 Autres établissements publics et organismes internationaux',
    value: '29',
  },
  {
    key: '50',
    text: '50 Personnes morales de droits PRIVÉ autres qu\'organismes sociaux',
    value: '50',
  },
  {
    key: '60',
    text: '60 Caisses de sécurité sociale régime général',
    value: '60',
  },
  {
    key: '61',
    text: '61 Caisses de sécurité sociale régime agricole',
    value: '61',
  },
  {
    key: '62',
    text: '62 Sécurité sociale des travailleurs Non salariés et professions Non agricoles',
    value: '62',
  },
  {
    key: '63',
    text: '63 Autres régimes obligatoires de sécurité sociale',
    value: '63',
  },
  {
    key: '64',
    text: '64 Mutuelles et organismes d\'assurance',
    value: '64',
  },
  {
    key: '65',
    text: '65 Divers autres tiers payants',
    value: '65',
  },
  {
    key: '70',
    text: '70 CNRACL',
    value: '70',
  },
  {
    key: '71',
    text: '71 IRCANTEC',
    value: '71',
  },
  {
    key: '72',
    text: '72 ASSEDIC',
    value: '72',
  },
  {
    key: '73',
    text: '73 Caisses mutualistes de retaites complémentaires',
    value: '73',
  },
];

export default categoriesPes;
